<template>
  <div
      class="returnable-items-view">
    <el-card
        class="item-card"
        :class="{'highlighted-item-card' : isSelected}">
      <img
          v-if="images && images.length && images[0].src"
          class="item-image"
          :alt="images[0].alt"
          :src="images[0].src">
      <div
          style="margin-left: 8px"
          class="flex-auto">
        <div class="flex flex-row">
          <div class="item-name flex-1">
            {{ title }}
          </div>
        </div>
        <div class="item-sku">
          ASIN: &nbsp;{{ sku }}
        </div>
      </div>
      <ItemReturnReasons
          v-if="(isSelected && !allSelected) || (allSelected && selectedReason)"
          :return-reasons="returnReasons"
          :selected-reason="selectedReason"
          :all-checked="allSelected"
          @selected-reason="setSelectedReason" />
      <el-checkbox
          :value="isSelected"
          style="margin-right: 16px"
          @change="toggleSelection" />
    </el-card>
  </div>
</template>

<script>
import AllReturnReasons from "./AllReturnReasons.vue";
import ItemReturnReasons from "./ItemReturnReasons.vue";

export default {
  name: "ReturnableOrderItemView",
  components: { ItemReturnReasons, AllReturnReasons },
  props: {
    id: {
      type: Number,
      default() {
        return 0;
      },
    },
    title: {
      type: String,
      default() {
        return "NA";
      },
    },
    sku: {
      type: String,
      default() {
        return "NA";
      },
    },
    images: {
      type: Array,
      default: () => {
        return [];
      },
    },
    returnReasons: {
      type: Array,
      default: () => {
        return [];
      },
    },
    allSelected: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    selectedReason: {
      type: Number,
      default: null,
    },
  },
  computed: {
    devicePicture() {
      return this.images[0];
    },
  },
  methods: {
    toggleSelection(value) {
      this.$emit("update:selected", value);
      this.$emit("update:reason", null);
      if (!value) {
        this.$emit("uncheckSelectAll");
      }
    },
    setSelectedReason(value) {
      this.$emit("update:reason", value);
    },
  },
};
</script>

<style>
.item-name {
  height: 24px;
  font-family: "Equip", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #424242;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  margin-top: 15px;
}

.item-sku {
  height: 24px;
  font-family: "Equip", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  align-items: flex-end;
  color: #6e6e6e;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
  margin-top: 2px;
}
.returnable-items-view {
  .item-card {
    padding: 8px;
    margin-right: 0px !important;
    height: 80px;
    box-shadow: none !important;
  }
  .item-image {
    height: 80px;
    width: 80px;
  }
  .highlighted-item-card {
    background: #eff8fc;
    border: 2px solid #1998d5;
    border-radius: 4px;
  }
}
.order-return-select-items {
  .el-checkbox {
    align-items: center;
    display: flex;
    margin-left: 16px;
    justify-content: center;
  }
  .el-checkbox__inner {
    width: 24px;
    height: 24px;
    border: 1px solid #81919f;
  }
  .el-checkbox__inner::after {
    width: 3.94px;
    height: 9.2px;
    top: 5px;
    left: 8px;
  }
}
</style>
